import Vue from 'vue'
import axios from 'axios'
import store from '../store'

function getAuthImage(vnode, binding) {
  axios({
    method: 'get',
    url: binding.value,
    responseType: 'blob'
  }).then(response => {
    let reader = new FileReader()
    reader.onload = () => {
      vnode.child.src = reader.result
    }
    reader.readAsDataURL(response.data)
  }).catch((function() {
    vnode.child.src = binding.value
  }))
}

Vue.directive('auth-src', {
  inserted: function(el, binding, vnode) {
    getAuthImage(vnode, binding)
  },
  update: function(el, binding, vnode) {
    getAuthImage(vnode, binding)
  }
})
